import { _ } from "libs";
import moment from "moment";

// if today display hour
// if yesterday display yesterday, hour
// if 2 to 6 days old display name of day eg Wed, hour
// if more then 6 days old, display date Aug 7, hour

export function messageRelativePastTime(time: any) {
	let reference = moment(time),
		now = moment(),
		yesteday = now
			.clone()
			.subtract(1, "days")
			.startOf("day"),
		weekOld = now
			.clone()
			.subtract(6, "days")
			.startOf("day");

	if (reference.isSame(now, "day")) {
		return reference.format("H:mm");
	}

	if (reference.isSame(yesteday, "day")) {
		return _("yesterday") + ", " + reference.format("H:mm");
	}

	if (reference.isAfter(weekOld)) {
		return reference.format("ddd") + ", " + reference.format("H:mm");
	}

	return reference.format("MMM D") + ", " + reference.format("H:mm");
}
